// src/data/languages.ts
export interface Language {
  code: string;
  flag: string;
  label: string;
  nativeLabel: string;
}

export const LANGUAGES: Language[] = [
  { code: "english", flag: "🇺🇸", label: "English", nativeLabel: "English" },
  { code: "hindi", flag: "🇮🇳", label: "Hindi", nativeLabel: "हिन्दी" },
  { code: "afrikaans", flag: "🇿🇦", label: "Afrikaans", nativeLabel: "Afrikaans" },
  { code: "arabic", flag: "🇦🇪", label: "Arabic", nativeLabel: "العربية" },
  { code: "bengali", flag: "🇧🇩", label: "Bengali", nativeLabel: "বাংলা" },
  { code: "chinese", flag: "🇨🇳", label: "Chinese", nativeLabel: "中文" },
  { code: "french", flag: "🇫🇷", label: "French", nativeLabel: "Français" },
  { code: "german", flag: "🇩🇪", label: "German", nativeLabel: "Deutsch" },
  { code: "italian", flag: "🇮🇹", label: "Italian", nativeLabel: "Italiano" },
  { code: "japanese", flag: "🇯🇵", label: "Japanese", nativeLabel: "日本語" },
  { code: "portuguese", flag: "🇵🇹", label: "Portuguese", nativeLabel: "Português" },
  { code: "russian", flag: "🇷🇺", label: "Russian", nativeLabel: "Русский" },
  { code: "spanish", flag: "🇪🇸", label: "Spanish", nativeLabel: "Español" },
  { code: "tagalog", flag: "🇵🇭", label: "Tagalog", nativeLabel: "Tagalog" },
  { code: "tamil", flag: "🇮🇳", label: "Tamil", nativeLabel: "தமிழ்" },
  { code: "turkish", flag: "🇹🇷", label: "Turkish", nativeLabel: "Türkçe" },
  { code: "urdu", flag: "🇵🇰", label: "Urdu", nativeLabel: "اردو" },
];

export const DEFAULT_LANGUAGE = "english";
